// @flow

import React from 'react'
import logo from '../../../assets/img/YA_logo.svg'
import css from './AdminHeader.css'
import {Link} from 'react-router-dom'

type Props = {
  showLogout: boolean,
  onLogout: Function,
}

const Header = ({showLogout, onLogout}: Props) => {
  return (
    <header className={css.component}>
      <div className={css.wrapper}>
        <Link to="/">
          <img className={css.logo} src={logo} alt="Yliopiston apteekin logo" />
        </Link>
        {showLogout && (
          <a onClick={() => onLogout()} className={css.logoutLink}>Kirjaudu ulos</a>
        )}
      </div>
    </header>
  )
}

export default Header



// WEBPACK FOOTER //
// ./src/admin/components/AdminHeader.js